<template>
    <div id="wrapper">
        <SidebarView :roTransfer="true" :members="true" :memberVisible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />


                
                <div class="container-fluid">
                    <div class="row">
                            <b-card no-body class="card-shape home-box">
                                <b-tabs card>
                                    <b-tab title="Single RO Transfer" active>
                                    <SingleRoTransfer/>
                                    </b-tab>
                                    <b-tab title="Multiple RO Transfer">
                                    <MemberUpdateImport/>
                                    </b-tab>
                                    <!-- <b-tab title="Beneficiary Imports">
                                    <BeneficiaryImport/>
                                    </b-tab> -->
                                </b-tabs>
                            </b-card>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from 'vue-multiselect';
import ChatBot from "@/views/components/AI/ChatBot.vue";
import SingleRoTransfer from "./modals/SingleRoTransfer.vue";
import MemberUpdateImport from "./modals/MultipleRoTransfer.vue";

export default {
    name: 'COAReconciliationEntry',
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        ChatBot,
        SingleRoTransfer,
        MemberUpdateImport,
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>